(function (angular) {
    var KeyPadController = (function () {
        function KeyPadController() {
            this.init.apply(this, arguments);
        }

        KeyPadController.prototype = {
            init: function ($scope, $element, $timeout) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$timeout = $timeout;
                this.bindEvents();
                this.watch();

                this.makeCenter();
                $(window).bind("resize.keypad", angular.bind(this, function () {
                    this.makeCenter();
                }));

            },
            watch:function(){
                this.$scope.$on("$destroy",function(){
                    $(window).unbind("resize.keypad");
                });
            },
            bindEvents: function () {
                var self = this,
                    allowMouseDown = true,
                    $outEl = $(this.$scope.selector);
                this.$element.find(".keypad").bind("mousedown touchstart", function (event) {
                    if (event.type === 'touchstart') {
                        allowMouseDown = false;
                    }
                    if (event.type === 'mousedown' && !allowMouseDown) {
                        allowMouseDown = true;
                        return;
                    }
                    var $el = $(this);
                    $el.addClass("keypad_clicked");


                    //Repeat button
                    var canRepeat = $el.attr('repeat') === "1";
                    var timer = null;
                    var repeat = false;

                    function keyup() {
                        $(window).unbind("touchend.keypad touchcancel.keypad mouseup.keypad");
                        $el.removeClass("keypad_clicked");
                        clearInterval(timer);
                        if (!repeat) {
                            $el.triggerHandler("tapone");
                        }
                    }

                    if (canRepeat) {
                        timer = setInterval(function () {
                            repeat = true;
                            $el.triggerHandler("tapone");
                            if (!self.$scope.ngModel)//stop repeat
                            {
                                keyup();
                            }
                        }, 200);
                        $(window).bind("touchend.keypad mouseup.keypad", function () {
                            keyup();
                        });
                    }
                    else {
                        $(window).bind("touchend.keypad touchcancel.keypad mouseup.keypad", function (ev) {
                            keyup();
                        });
                    }


                });

                this.$element.find(".keypad-number").on("tapone", function () {
                    var number = $(this).attr("data-value");
                    self.addNumber(number);
                    $outEl.text(self.$scope.ngModel);
                    self.valid($outEl);
                });
                this.$element.find(".keypad-delete").on("tapone", function () {
                    self.removeLastNumber();
                    $outEl.text(self.$scope.ngModel);
                    self.valid($outEl);
                });
                this.$element.find(".keypad-clear").on("tapone", function () {
                    self.$scope.ngModel = "";
                    $outEl.text(self.$scope.ngModel);
                    self.valid($outEl);
                });
            },
            valid: function ($outEl) {
                var value = this.$scope.ngModel;
                if (value && value > 0) {
                    $outEl.removeClass("ng-invalid");
                }
                else {
                    $outEl.addClass("ng-invalid");
                }

            },
            removeLastNumber: function () {
                var odometerReading = this.$scope.ngModel;
                if (odometerReading === null || odometerReading === undefined || isNaN(odometerReading))
                    odometerReading = "";

                odometerReading = odometerReading.toString();
                if (odometerReading.length <= 1) {
                    this.$scope.ngModel ="";
                }
                else {
                    odometerReading = odometerReading.substr(0, odometerReading.length - 1);
                    this.$scope.ngModel = parseInt(odometerReading);
                }
            },
            addNumber: function (number) {
                var odometerReading = this.$scope.ngModel || '';
                if (odometerReading.toString().length >= this.$scope.maxlength)
                    return;
                var newValue = odometerReading.toString() + number;
                if (isNaN(parseInt(newValue))) {
                    newValue = 0;
                }
                this.$scope.ngModel = parseInt(newValue);
            },
            makeCenter: function () {
                var footer = $(".footer-buttons");
                var minheight=80;
                if(footer.hasClass("footer-buttons-update-disconnect"))
                    minheight=160;


                //reset style
                $(".keyboard-container").css({
                    height: 'auto'
                });
                $("#newuichargingrequest-page").removeClass('keypad-no-square');

                //Is Square
                if (footer.height() > minheight) {
                    return;
                }
                var height = this.$element.height(),
                    hFooter = footer.height(),
                    tFooter = footer.offset().top;
                var h = hFooter - ($(window).height() - tFooter);
                var kbcHeight = height - h;
                $(".keyboard-container").height(kbcHeight);
                $("#newuichargingrequest-page").addClass('keypad-no-square');
            }
        };
        KeyPadController.$inject = ['$scope', '$element', '$timeout'];
        return KeyPadController;
    }());

    angular.module('shared').directive('nfKeypad', function () {
        return {
            restrict: 'E',
            controller: KeyPadController,
            templateUrl: 'js/shared/directives/keypad/keypad.html',
            scope: {
                ngModel: '=',
                selector: '@',
                maxlength: '='
            }
        };
    });

}(angular));